<template>
  <ax-dialog 
    ref="dialog"
    title="Decline type curves" 
    icon="mdi-cog-outline" 
    tooltip="Decline type curves" 
    size="medium" 
    :disabled="disabled" 
    @submitted="onSubmit"
  >
    <template slot="content">
      <v-card-text>
        <p class="text-subtitle-1">Please select range of months to use for fitting the decline curve</p>
        <v-range-slider v-model="range" min="1" :max="months" thumb-label>
          <template v-slot:prepend>
            <v-text-field
              hint="Start Month" persistent-hint
              :value="range[0]"
              class="mt-0 pt-0"
              single-line
              type="number"
              style="width: 70px"
              @change="$set(range, 0, $event)"
            ></v-text-field>
          </template>
          <template v-slot:append>
            <v-text-field
              hint="End Month" persistent-hint
              :value="range[1]"
              class="mt-0 pt-0"
              single-line
              type="number"
              style="width: 70px"
              @change="$set(range, 1, $event)"
            ></v-text-field>
          </template>
        </v-range-slider>
      </v-card-text>
    </template>
    <template slot="submit_text"> Decline </template>
  </ax-dialog>
</template>
<script>
import AxDialog from '@/components/dialog'
export default {
  name: "dlgDeclineTypeCurves",
  props: {
    months: { type: Number, required: true },
    disabled: { type: Boolean, default: false },
  },
  components: {
    AxDialog
  },
  data() {
    return {
      range: [],
    }
  },
  created() {
    this.range = [1, this.months]
  },
  methods: {
    onSubmit() {
      this.$refs.dialog.show = false
      this.$emit('submitted', this.range)
    }
  }
}
</script>